<div class="grid-block" *ngIf="!onlyRouterShow">
  <app-header [notAvailable]="notAvailable" [ngClass]="{'mobile-hidden' : pathCheck()}"></app-header>
  <app-universal-callback-button></app-universal-callback-button>

  <ng-container *ngIf="notAvailable">
    <app-site-unavailable></app-site-unavailable>
  </ng-container>

  <ng-container *ngIf="!notAvailable">
    <div class="main" [ngClass]="{'account-bg': greyPages()}">
      <div class="i-container">
        <div class="i-row">
          <div class="home-content">
            <router-outlet></router-outlet>
            <app-footer></app-footer>
          </div>
        </div>
      </div>
    </div>
  </ng-container>
</div>

<router-outlet *ngIf="onlyRouterShow"></router-outlet>
